import React from "react";

import { motion } from "framer-motion";

/* TEAM IMAGES */

import team1 from "@/assets/member.jpg";
import team2 from "@/assets/member.jpg";
import team3 from "@/assets/member.jpg";
import team4 from "@/assets/member.jpg";

const TEAM = [
  {
    name: "James Anderson",
    role: "President and CEO",
    image: team1,
  },
  {
    name: "Ibtehaj Syed",
    role: "Director and HR Head",
    image: team2,
  },
  {
    name: "Daniel Foster",
    role: "Chief Marketing Officer",
    image: team3,
  },
  {
    name: "Abraham J. Mitchel",
    role: "Chief Financial Officer",
    image: team4,
  },
];

export default function Team() {

  return (
    <>
      {/* PREMIUM STYLES */}

      <style>
        {`

          /* ===================================================== */
          /* TEAM CARD */
          /* ===================================================== */

          .team-card {

            position: relative;

            overflow: hidden;

            border-radius: 32px;

            background:
              rgba(255,255,255,0.72);

            backdrop-filter:
              blur(24px);

            border:
              1px solid rgba(180,140,255,0.18);

            box-shadow:
              0 12px 40px rgba(120,70,180,0.08);

            transition:
              all 0.5s ease;
          }

          .team-card:hover {

            transform:
              translateY(-10px);

            border-color:
              rgba(180,140,255,0.32);

            box-shadow:
              0 30px 70px rgba(120,70,180,0.16);
          }

          /* ===================================================== */
          /* IMAGE */
          /* ===================================================== */

          .team-image-wrap {

            position: relative;

            background:
              linear-gradient(
                180deg,

                #F8F4FB 0%,

                #EEE3F8 100%
              );
          }

          .team-image {

            transition:
              transform 0.8s ease;
          }

          .team-card:hover .team-image {

            transform:
              scale(1.06);
          }

          /* ===================================================== */
          /* GLOW */
          /* ===================================================== */

          .team-glow {

            position: absolute;

            inset: auto;

            top: -40px;
            right: -40px;

            width: 160px;
            height: 160px;

            border-radius: 999px;

            background:
              rgba(168,85,247,0.18);

            filter:
              blur(70px);

            opacity: 0;

            transition:
              opacity 0.5s ease;
          }

          .team-card:hover .team-glow {

            opacity: 1;
          }

          /* ===================================================== */
          /* MOBILE FLOATING ANIMATION */
          /* ===================================================== */

          @keyframes mobileFloat {

            0% {
              transform:
                translateY(0px);
            }

            50% {
              transform:
                translateY(-8px);
            }

            100% {
              transform:
                translateY(0px);
            }
          }

          @keyframes mobileGlow {

            0% {
              opacity: 0.4;
              transform: scale(1);
            }

            50% {
              opacity: 0.9;
              transform: scale(1.08);
            }

            100% {
              opacity: 0.4;
              transform: scale(1);
            }
          }

          /* ===================================================== */
          /* MOBILE OPTIMIZATION */
          /* ===================================================== */

          @media (max-width: 768px) {

            .team-card {

              border-radius: 28px;

              animation:
                mobileFloat 5s ease-in-out infinite;
            }

            .team-card:nth-child(2) {

              animation-delay: 0.8s;
            }

            .team-card:nth-child(3) {

              animation-delay: 1.6s;
            }

            .team-card:nth-child(4) {

              animation-delay: 2.4s;
            }

            .team-card:hover {

              transform:
                translateY(-6px);
            }

            .team-glow {

              opacity: 0.45;

              animation:
                mobileGlow 4s ease-in-out infinite;
            }

            .team-image-wrap {

              height: 320px;
            }

          }

          /* ===================================================== */
          /* SMALL MOBILE */
          /* ===================================================== */

          @media (max-width: 480px) {

            .team-image-wrap {

              height: 280px;
            }

          }

        `}
      </style>

      <section

        className="
          relative

          py-24 md:py-32

          overflow-hidden

          bg-gradient-to-b
          from-white
          via-[#F8F4FB]
          to-white
        "

        data-testid="team-section"
      >

        {/* LEFT GLOW */}

        <div
          className="
            absolute

            top-[-120px]
            left-[-120px]

            w-[480px]
            h-[480px]

            bg-purple-300/12

            rounded-full

            blur-[120px]

            pointer-events-none
          "
        />

        {/* RIGHT GLOW */}

        <div
          className="
            absolute

            bottom-[-120px]
            right-[-120px]

            w-[420px]
            h-[420px]

            bg-fuchsia-300/10

            rounded-full

            blur-[120px]

            pointer-events-none
          "
        />

        {/* GRID OVERLAY */}

        <div
          className="
            absolute inset-0

            grid-bg

            opacity-[0.03]
          "
        />

        <div
          className="
            relative

            max-w-7xl
            mx-auto

            px-5 md:px-8
          "
        >

          {/* HEADING */}

          <div
            className="
              max-w-3xl

              mb-14 md:mb-16
            "
          >

            <div
              className="
                text-xs md:text-sm

                uppercase

                tracking-[0.35em]

                text-purple-600

                font-bold

                mb-4
              "
            >

              Leadership Team

            </div>

            <h2
              className="
                text-3xl
                sm:text-4xl
                md:text-5xl

                font-bold

                tracking-tight

                text-slate-900

                leading-tight
              "
              style={{
                fontFamily: "Sora",
              }}
            >

              Meet the experts
              <br />

              <span className="text-slate-400">

                behind our innovation.

              </span>

            </h2>

            <p
              className="
                mt-6

                text-base
                md:text-lg

                text-slate-600

                leading-relaxed
              "
            >

              Our experienced leadership team
              combines innovation, technical
              expertise, and strategic thinking
              to deliver exceptional business
              solutions worldwide.

            </p>

          </div>

          {/* TEAM GRID */}

          <div
            className="
              grid

              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-4

              gap-6 md:gap-8
            "
          >

            {TEAM.map((member, index) => (

              <motion.div
                key={member.name}

                initial={{
                  opacity: 0,
                  y: 40,
                }}

                whileInView={{
                  opacity: 1,
                  y: 0,
                }}

                viewport={{
                  once: true,
                  margin: "-50px",
                }}

                transition={{
                  duration: 0.7,
                  delay: index * 0.08,
                }}

                className="team-card"

                data-testid={`team-card-${index}`}
              >

                {/* HOVER GLOW */}

                <div className="team-glow" />

                {/* IMAGE */}

                <div
                  className="
                    team-image-wrap

                    h-[400px]

                    overflow-hidden
                  "
                >

                  <img
                    src={member.image}

                    alt={member.name}

                    loading="lazy"

                    className="
                      team-image

                      w-full
                      h-full

                      object-cover
                      object-top
                    "
                  />

                  {/* DARK OVERLAY */}

                  <div
                    className="
                      absolute inset-0

                      bg-gradient-to-t
                      from-black/20
                      via-transparent
                      to-transparent
                    "
                  />

                </div>

                {/* CONTENT */}

                <div
                  className="
                    relative

                    p-6 md:p-7

                    text-center
                  "
                >

                  <h3
                    className="
                      text-xl

                      font-semibold

                      text-slate-900
                    "
                    style={{
                      fontFamily: "Sora",
                    }}
                  >

                    {member.name}

                  </h3>

                  <p
                    className="
                      mt-3

                      text-xs md:text-sm

                      font-semibold

                      uppercase

                      tracking-[0.18em]

                      text-purple-600
                    "
                  >

                    {member.role}

                  </p>

                </div>

              </motion.div>

            ))}

          </div>

        </div>

      </section>
    </>
  );
}